import React, { FC, useMemo } from 'react';
import { Navigate, Outlet } from 'react-router';

import { isAddressEqual } from 'viem';

import { useGetRoleMember } from '@services/contract/fusion/nftFusion.contract';

import { useAuth } from '@contexts/common/AuthorizationContext';

import { isAddressesEqual } from '@utils/tokens.utils';

import Loader from '@components/common/Loader';

import { DEFAULT_CAIN_ID } from '@constants/common/chain.constants';
import { ADMINS_LIST_ADDRESS } from '@constants/common/common.constants';
import {
  PATH_ADMIN,
  PATH_NFT_TRANSFER,
} from '@constants/common/routes.constants';

interface Props {
  path: string;
  redirectPath: string;
}

export const PrivateRoute: FC<Props> = ({ path, redirectPath }) => {
  const { account, isConnected, isAuthReady } = useAuth();

  const isNftTransferPath = path === PATH_NFT_TRANSFER;

  const { data: roleMemberList, isPending: isRoleMemberPending } =
    useGetRoleMember(isNftTransferPath ? DEFAULT_CAIN_ID : undefined);

  const isAllowed = useMemo(() => {
    if (!account || !isConnected) return false;

    if (path === PATH_ADMIN) {
      return ADMINS_LIST_ADDRESS.some((admin) =>
        isAddressEqual(admin, account),
      );
    }

    if (isNftTransferPath) {
      return !!roleMemberList?.some((item) => isAddressesEqual(account, item));
    }

    return true;
  }, [path, account, isConnected, isNftTransferPath, roleMemberList]);

  if (!isAuthReady || (isNftTransferPath && isRoleMemberPending)) {
    return (
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Loader size={36} />
      </div>
    );
  }

  return isAllowed ? <Outlet /> : <Navigate to={redirectPath} replace />;
};
